module.exports = __webpack_public_path__ + "img/tester_02.cb2554ab.png";